<template>
  <div ref="tooltip" class="tooltip" :class="position">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CTooltip",
  props: ["action", "position"],

  beforeUpdate() {
    this.change();
  },

  mounted() {
    this.change(true);
  },

  methods: {
    closeIt(e) {
      let itIs = false;
      for (let t = e.target; t !== document.body; t = t.parentNode) {
        if (t.matches(".tooltip")) {
          itIs = true;
        }
      }
      if (!itIs) {
        document.querySelectorAll(".tooltip-on").forEach(t => {
          t.classList.remove("tooltip-on");
        });
        document.removeEventListener("mousedown", this.closeIt);
      }
    },
    change(forced = false) {
      if (this.action === false) {
        if (this.$refs.tooltip.classList.contains("tooltip-on")) {
          this.$refs.tooltip.classList.remove("tooltip-on");
        }
      } else {
        if (!forced) {
          this.GAEvent(
            "question_click",
            "question_mark",
            this.$refs["tooltip"].innerText
          );
        }
        if (!this.$refs.tooltip.classList.contains("tooltip-on")) {
          this.$refs.tooltip.classList.add("tooltip-on");
        }
        let position = this.$refs.tooltip.getBoundingClientRect();
        if (position.x + position.width > outerWidth) {
          this.$refs.tooltip.classList.remove("right");
          this.$refs.tooltip.classList.remove("left");
          this.$refs.tooltip.classList.remove("top");
          this.$refs.tooltip.classList.remove("down");
          this.$refs.tooltip.classList.add("bottom");
        } else if (position.x < 0) {
          this.$refs.tooltip.classList.remove("right");
          this.$refs.tooltip.classList.remove("left");
          this.$refs.tooltip.classList.remove("top");
          this.$refs.tooltip.classList.remove("bottom");
          this.$refs.tooltip.classList.add("bottom");
        }
        document.addEventListener("mousedown", this.closeIt);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip {
  background-color: #3a5eec;
  padding: 15px;
  border-radius: 5px;
  color: #ffffff;
  position: absolute;
  width: 232px;
  z-index: 9;
  display: none;
}
.tooltip::after {
  content: " ";
  position: absolute;
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  z-index: 10;
}
.tooltip-on {
  display: block;
}

.right {
  top: 50%;
  transform: translate(100%, -50%);
  right: -9px;
}
.right::after {
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  border-color: transparent #3a5eec transparent transparent;
}

.left {
  top: 50%;
  transform: translate(-100%, -50%);
  left: -8px;
}
.left::after {
  top: 50%;
  left: 100%; /* To the left of the tooltip */
  border-color: transparent transparent transparent #3a5eec;
}

.top {
  top: -8px;
  transform: translate(-50%, -100%);
  left: 50%;
}
.top::after {
  top: 100%;
  left: calc(50% - 9px);
  border-color: #3a5eec transparent transparent transparent;
  margin-top: 0;
}

.bottom {
  top: 5px;
  transform: translate(-50%, 50%);
  left: 50%;
}
.bottom::after {
  top: -7px;
  left: calc(50% - 9px);
  border-color: transparent transparent #3a5eec transparent;
}
</style>
